<template>
	<div>
    <div class="windowContainer">
        <ticket-window
          :ticketOptions="ticketOptions">
        </ticket-window> 
    </div>
    <button class="btnTicket icon-box bg-darkgrey" type="button" data-toggle="collapse" data-target="#ticketWindow" aria-expanded="false" @click="initializeDataValues()">
      <i class="fa fa-bug" aria-hidden="true" />
    </button>
	</div>
</template>

<script>
  import TicketWindow from './TicketWindow.vue'
  // import _ from 'lodash'

  export default {
    components: {
      TicketWindow
    },
    data () {
      return {
        ticketOptions: {},
        isTicketOpened: false
      }
    },
    created () {
      this.isScreenSmall = window.innerWidth < 800
    },

    methods: {
      initializeDataValues () {
        if (!this.isTicketOpened) {
          this.ticketOptions = {
            ticketPage: {
              value: '1',
              name: this.$t('Ticket.ticketOptions.page')
            },
            ticketOrder: {
              value: '2',
              name: this.$t('Ticket.ticketOptions.order')
            },
            ticketFeature: {
              value: '3',
              name: this.$t('Ticket.ticketOptions.feature')
            },
            ticketSupport: {
              value: '4',
              name: this.$t('Ticket.ticketOptions.support')
            },
            ticketFeedback: {
              value: '5',
              name: this.$t('Ticket.ticketOptions.feedback')
            }
          }
        }

        this.isTicketOpened = true
      },
      onResize: window._.debounce(function () {
        this.isScreenSmall = window.innerWidth < 800
      }, 50)
    },

    computed: {
      showOptions () {
        return !this.isDevice || this.showDemoOptions
      },
      uid () {
        return this.$store.state.user.uid
      }
    },

    mounted () {
      this.onResize()
      window.addEventListener('resize', this.onResize, { passive: true })
    },

    watch: {
    },

    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    }
  }
  </script>

  <style scoped>
  .btnTicket {
    transition: all 0.25s ease;
    font-size: 0.85rem;
    padding: 0;
  }

  .btnTicket:hover {
    animation-timing-function: linear;
    animation-duration: 0.25s;
    animation-fill-mode: forwards;
    color: rgba(255, 255, 255, 0.95) !important;
  }

  .icon-box {
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    cursor: pointer;
    height: 1.6rem;
    width: 1.6rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
</style>
